export default __webpack_public_path__ + "static/media/showroom31.f5a70fd4.webp";